export default __webpack_public_path__ + "static/media/socketio.ab2009fb.svg";